/**
 * @deprecated
 */
export function RenderAfterNavermapsLoaded() {
  throw new Error('react-naver-maps: v0.1 부터 <RenderAfterNavermapsLoaded /> 는 더이상 사용되지 않습니다. 마이그레이션 가이드를 확인해주세요. https://zeakd.github.io/react-naver-maps/guides/migration-guide-from-0.0');
}
